import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between items-center" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex justify-between items-baseline my-5" }
const _hoisted_6 = { class: "text-2xl" }
const _hoisted_7 = { class: "text-xl" }
const _hoisted_8 = { class: "grid md:grid-cols-2 xl:grid-cols-4 gap-3 overflow-x-auto" }
const _hoisted_9 = { class: "flex justify-between items-center mt-7 mb-3" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ModalProgetto = _resolveComponent("ModalProgetto")!
  const _component_ModalSottoProgetto = _resolveComponent("ModalSottoProgetto")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardDivisorioGrigio = _resolveComponent("CardDivisorioGrigio")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"]),
      _createVNode(_component_ModalProgetto, {
        onSaved: _ctx.onUpdateProgetto,
        create: false,
        id: _ctx.id,
        visible: _ctx.visible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event))
      }, null, 8, ["onSaved", "id", "visible"]),
      _createVNode(_component_ModalSottoProgetto, {
        defaultValue: _ctx.sottoprogettoDefaultValue,
        onSaved: _ctx.onAddSottoProgetto,
        progetto_id: _ctx.id,
        progetto_is_promo: _ctx.progetto_model.promo,
        onChiudi: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sp_visible = false)),
        cliente_id: _ctx.progetto_model.cliente_id,
        visible: _ctx.sp_visible,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sp_visible) = $event))
      }, null, 8, ["defaultValue", "onSaved", "progetto_id", "progetto_is_promo", "cliente_id", "visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible=true)),
              variant: "outline-secondary",
              class: "w-44 text-sm py-2 px-4"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode(" Modifica ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("b", null, _toDisplayString(_ctx.progetto_model.titolo), 1)
          ]),
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("b", null, "ID PROGETTO: " + _toDisplayString(_ctx.progetto_model.id_gamma), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Denominazione cliente")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: {name:'DettaglioAzienda', params:{id:_ctx.azienda_progetto?.id}},
                class: "text-next-stato-7 dark:text-next-stato-6 hover:underline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.azienda_progetto?.denominazione || '-'), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Ragione sociale cliente")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.azienda_progetto?.ragione_sociale || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Committente")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.committente_progetto?.ragione_sociale || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Azienda")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.azienda_gruppo?.nome), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Data di inizio")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.progetto_model.data_inizio ? _ctx.$filters.toDate(_ctx.progetto_model.data_inizio) : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Data di fine")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.progetto_model.data_fine ? _ctx.$filters.toDate(_ctx.progetto_model.data_fine) : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[13] || (_cache[13] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Budget di apertura")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.progetto_model.budget ? _ctx.$filters.toEuroCurrency(_ctx.progetto_model.budget) : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_CardDivisorioGrigio, null, {
            top: _withCtx(() => _cache[14] || (_cache[14] = [
              _createElementVNode("div", { class: "text-sm" }, [
                _createElementVNode("b", null, "Budget preventivo")
              ], -1)
            ])),
            bottom: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.progetto_model.budgetConsuntivo ? _ctx.$filters.toEuroCurrency(_ctx.progetto_model.budgetConsuntivo) : '-'), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-xl" }, "Sottoprogetti", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sp_visible=true)),
              class: "w-44 text-sm py-2 px-4"
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode(" + Aggiungi ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed",
            cols: _ctx.sottoProgettiCols,
            "onUpdate:cols": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sottoProgettiCols) = $event)),
            rows: _ctx.listaSottoprogettiProgetto.rows,
            onOrderUpdate: _ctx.listaSottoprogettiProgetto.updateCols
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.listaSottoprogettiProgetto.rows, (c, j) => {
              return {
                name: `td_${j}_2`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.bu.find(el=>el.id == c.business_unit_id)?.label), 1)
                ])
              }
            }),
            _renderList(_ctx.listaSottoprogettiProgetto.rows, (c, j) => {
              return {
                name: `td_${j}_3`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_inizio)), 1)
                ])
              }
            }),
            _renderList(_ctx.listaSottoprogettiProgetto.rows, (c, j) => {
              return {
                name: `td_${j}_4`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.data_fine)), 1)
                ])
              }
            }),
            _renderList(_ctx.listaSottoprogettiProgetto.rows, (c, j) => {
              return {
                name: `td_${j}_5`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.context.row.budget)), 1)
                ])
              }
            }),
            _renderList(_ctx.listaSottoprogettiProgetto.rows, (c, j) => {
              return {
                name: `td_${j}_6`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(context.context.row.stato_next_descrizione), 1)
                ])
              }
            }),
            _renderList(_ctx.listaSottoprogettiProgetto.rows, (c, j) => {
              return {
                name: `td_${j}_7`,
                fn: _withCtx((context) => [
                  _createVNode(_component_router_link, {
                    to: {name:'DettaglioSottoProgetto', params:{id:context.context.row.id}},
                    class: "text-center inset-0 absolute flex items-center justify-center"
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                    ])),
                    _: 2
                  }, 1032, ["to"])
                ])
              }
            })
          ]), 1032, ["cols", "rows", "onOrderUpdate"])
        ]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.listaSottoprogettiProgetto.fetchNextPage,
          identifier: _ctx.listaSottoprogettiProgetto.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[18] || (_cache[18] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri sottoprogetti.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}